import createStore from 'kolibri-common/utils/createStore';
import pluginModule from './modules/pluginModule';

export default createStore(pluginModule);
